<template>
  <div class="video-iframe-wrap relative w-full h-full bg-white flex justify-center">
    <div
      v-show="loading"
      class="absolute left-0 top-0 w-full h-full flex items-center justify-center bg-black"
    >
      <Loading class="z-10" />
    </div>
    <iframe
      ref="iframeRef"
      class="relative w-full h-full"
      frameborder="0"
      allow="clipboard-read; clipboard-write;"
      allowfullscreen="allowfullscreen"
      @load="handleLoaded"
    />
    <NextBtn
      class="next-btn-position"
      :isShow="isNextBtnShow"
      @nextbtn-click="handleNextBtnClick"
    />
  </div>
</template>

<script lang="ts">
import { Content } from '@forchange/storytime';
import { Vue, Prop, Component } from 'vue-property-decorator';
import NextBtn from '../components/NextBtn.vue';
import Loading from '@/components/common/system-loading';
import { connectToChild, AsyncMethodReturns } from '@forchange/cleword-postmate';
interface connectionApi {
  onEnd?: (data: Content) => void;
}

@Component({
  components: {
    NextBtn,
    Loading
  }
})
export default class VideoIframe extends Vue {
  @Prop({ type: Object, default: () => {} }) content!: Content & {
    url: string;
    endButton: boolean;
    isEnd?: boolean;
  };
  @Prop() isInLookBack!: boolean;

  loading = true;

  isNextBtnShow = false;

  connection: AsyncMethodReturns<connectionApi> | null = null;

  handleNextBtnClick() {
    this.$emit('next');
  }

  handleLoaded() {
    this.loading = false;
  }

  async init() {
    const iframeRef = this.$refs.iframeRef as HTMLIFrameElement;
    if (!this.$refs.iframeRef) return;
    iframeRef.src = this.content.url;
    if (this.content?.endButton || this.isInLookBack || this.content?.isEnd) {
      this.isNextBtnShow = true;
      return;
    }

    this.connection = await connectToChild({
      iframe: iframeRef,
      methods: {
        onEnd: () => {
          this.isNextBtnShow = true;
          window.storyteller.updateAssignContent({
            $id: this.content.$id,
            $kind: this.content.$kind,
            ...{
              isEnd: true
            }
          });
        }
      },
      debug: true
    }).promise;
  }

  mounted() {
    this.init();
  }
}
</script>

<style scoped lang="scss">
.video-iframe-wrap {
  .next-btn-position {
    right: 3%;
  }
}
</style>
